import 'vuetify/styles'
import { createVuetify, type IconSet, type IconProps } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import { md3 } from 'vuetify/blueprints'
import type { VDataTable } from 'vuetify/lib/components/index.mjs'
export type DataTableHeaders = InstanceType<
  typeof VDataTable
>['$props']['headers']

function filename(path: string) {
  return path
    .split(/(\\|\/)/g)
    .pop()!
    .replace(/\.[^/.]+$/, '')
}

const svgIcons = Object.fromEntries(
  Object.entries(
    import.meta.glob('@/assets/icons/*.svg', {
      eager: true,
      query: '?raw',
      import: 'default',
    }),
  ).map(([k, v]) => [filename(k), v]),
)

const custom: IconSet = {
  component: (props: IconProps) =>
    h(props.tag, { innerHTML: svgIcons[props.icon as string] }),
}

// Light: deep forest green (professional, not minty) — dark end of Agrimetrie logo gradient
// Dark: lighter emerald so primary remains visible on dark surfaces
const lightColors = {
  primary: '#2D6A4F',
  secondary: '#52B788',
}

const darkColors = {
  primary: '#52B788',
  secondary: '#2D6A4F',
}

export default createVuetify({
  blueprint: md3,
  defaults: {
    VSwitch: {
      color: 'primary',
    },
    VDataTable: {
      fixedHeader: true,
      hover: true,
    },
    VCard: {
      flat: true,
      border: true,
    },
    VBtn: { color: undefined },
    VNavigationDrawer: {
      VList: {
        nav: true,
        VListItem: {
          rounded: 'xl',
        },
      },
    },
    VChip: { rounded: 'lg' },
  },
  theme: {
    themes: {
      light: {
        colors: lightColors,
      },
      dark: {
        colors: darkColors,
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi, custom },
  },
  display: {
    mobileBreakpoint: 'sm',
  },
  /*locale: {
    locale: 'fr',
  },*/
  date: {
    locale: {
      en: 'fr-CA',
    },
  },
})
